import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogCloseButton, Button, BUTTON_VARIANTS } from 'cdk-radial';
import { getPlansToShowForAPI } from '../../utils/apiPricingUtil';
import { APIPricingPlanTile } from '../APIPricingPlanTile';
import './APIPricingPlansModal.scss';
import { API_TYPE, RESOURCE_TYPES } from '../../../../constants/constants';
import { getInstanceIdVersionMap } from '../../../../utils/utils';

const MAX_PLANS_ON_PAGE = 3;

export const APIPricingPlansModal = (props) => {
  const { title = '', selectedAPI, isOpen, onClose, onAccept } = props;
  const state = useSelector((state) => state);
  const { apiInfo, fetchingAPIDetails } = state?.apiDirectorySlice;

  const { cart, addingPricingPlanToApiInCart } = state?.orderAPISlice;
  const [allEndpoints, setAllEndpoints] = useState([]);
  const [specVersions, setSpecVersions] = useState([]);
  const apiName = selectedAPI?.details?.name;
  const rawPlans = selectedAPI?.details?.plans || [];
  
  const plansToShow = getPlansToShowForAPI(rawPlans);

  const apiCartItem =
    Array.isArray(cart) && cart.find((api) => api.resourceId === selectedAPI?.resourceId);

  const selectedPricingPlan = apiCartItem?.resourcePricingPlanId;
  const isAPIContracted = selectedAPI?.details?.isContracted;
  const isAsync = selectedAPI?.resourceType === API_TYPE.ASYNC;

  const [selectedPlan, setSelectedPlan] = useState(selectedPricingPlan);

  const handlePricingPlanSelect = (planId) => {
    setSelectedPlan(planId);
  };

  const handleSave = () => {
    onAccept({
      resourceId: selectedAPI?.resourceId,
      resourceType: selectedAPI?.resourceType,
      resourcePricingPlanId: selectedPlan
    });
  };

  const renderCustomHeader = () => {
    return (
      <div className="api-pricing-dialog-header">
        <div className="api-pricing-dialog-title">{title}</div>
        <DialogCloseButton
          dataTestId="header-close-button"
          className="api-pricing-dialog-close-btn"
          onClick={onClose}
        />
      </div>
    );
  };

  const renderCustomFooter = () => {
    return (
      <div className="api-pricing-dialog-footer">
        <Button
          dataTestId="footer-save-button"
          className="api-pricing-dialog-footer-btn"
          onClick={handleSave}
          isLoading={addingPricingPlanToApiInCart}
          size="standard"
          text="Save"
          variant={BUTTON_VARIANTS.PRIMARY}
          isDisabled={selectedPricingPlan === selectedPlan || !selectedPlan}
        />
      </div>
    );
  };
  useEffect(() => {
    if (apiInfo && !fetchingAPIDetails) {
      const spec = apiInfo?.data.environments?.[0]?.instances?.[0]?.spec;
      let endpoints = [];

      if (isAsync) {
        const channels = spec?.channels || {};
        endpoints = Object.keys(channels);
      } else {
        const paths = spec?.paths || {};
        Object.keys(paths).forEach((resource) => {
          const methods = Object.keys(paths[resource] || {});
          methods.forEach((method) => {
            endpoints.push(
              `${method.toUpperCase()} ${
                paths[resource][method]?.summary || ''
              }`
            );
          });
        });
        setSpecVersions(getInstanceIdVersionMap(apiInfo.data));
      }

      setAllEndpoints(endpoints);
    }
  }, [apiInfo, fetchingAPIDetails]);

  return (
    <>
      <Dialog
        id="api-pricing"
        title={title}
        isOpen={isOpen}
        onClose={onClose}
        disableOverlayClicked={true}
        className="api-pricing-dialog"
        buttonsProps={[
          {
            id: 'api-pricing-save-btn',
            onClick: onAccept,
            text: 'Save',
            variant: BUTTON_VARIANTS.PRIMARY,
          },
        ]}
        renderCustomFooterComponent={renderCustomFooter}
        customHeaderTag={renderCustomHeader}
      >
        <div className="api-pricing-dialog-body">
          <div className="api-pricing-dialog-plan-container-header">
            {apiName}
          </div>
          <div className="api-pricing-dialog-divider" />
          <div
            className={`api-pricing-dialog-plans-container ${
              plansToShow?.length < MAX_PLANS_ON_PAGE ? 'centered' : ''
            }`}
          >
            {plansToShow.map((p) => {
              const isSelected = !isAPIContracted && p.id === selectedPlan;
              const isBundle = selectedAPI?.resourceType === RESOURCE_TYPES.BUNDLE;
              return (
                <div style={{ margin: '0px 12px' }} key={p.id}>
                  <APIPricingPlanTile
                    key={p.id}
                    plan={p}
                    isAsync={isAsync}
                    allEndpoints={allEndpoints}
                    instanceIdVersionMap={specVersions}
                    selectPricingPlan={handlePricingPlanSelect}
                    isSelected={isSelected}
                    isAPIinCart={true}
                    isAPIContracted={isAPIContracted}
                    isAPIPurchased={false}
                    isLoading={addingPricingPlanToApiInCart}
                    isBundle={isBundle}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>
    </>
  );
};
